// extracted by mini-css-extract-plugin
export default {"selectContainer":"auth_selectContainer__lRcHr"};